<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  // import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'creditStatisticsList',
    data() {
      let routeQuery = this.$route.query || null;
      return {
        footerTotalCols: {
          amount: ['requestAmount', 'availableAmount', 'usedAmount'],
        },
        load: false,
        img: './static/img/tips.png',
        query: {
          validDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          invalidDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          creditCode: '', //信用账户号
          projectName: '',
          projectList: [],
          projectCompanyCodeList: null,
          quotaType: null,
          creditType: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        creditTypeData: [],
        creditTypeList: [],
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          // { field: 'quotaTypeName', title: '额度维度' },
          { field: 'projectCode', title: '项目编号', sortable: true },
          { field: 'projectName', title: '项目名称', sortable: true },
          { field: 'projectCompanyCode', title: '公司代码', sortable: true },
          { field: 'projectCompanyName', title: '公司名称' },
          // { field: 'creditType', title: '额度类型' },
          { field: 'quotaTypeName', title: '账款类型' },
          /*{ field: 'creditTypeName', title: '授信类型' },
          { field: 'validDate', title: '授信有效期始' },
          { field: 'invalidDate', title: '授信有效期止' }, */
          { field: 'requestAmount', title: '项目授信额度（元）' },
          { field: 'availableAmount', title: '项目可用额度（元）' },
          { field: 'usedAmount', title: '项目占用额度（元）' },
          { field: 'createPersonName', title: '新增人' },
          { field: 'gmtCreate', title: '新增日期' },
        ],
        quotaTypeList: [],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          ...(this.isWuMaoAccount
            ? [
                {
                  name: '项目编号',
                  type: 'searchTableSpec',
                  isMultiple: false,
                  searchType: 'projectListWumao',
                  prop: 'projectList',
                  extraData: {
                    projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                    applyCompanyNo: this.userInfo.userInfo.companyCode,
                    applyCompanyName: this.userInfo.userInfo.companyName,
                  },
                },
              ]
            : [
                {
                  name: '项目编号',
                  type: 'searchTableSpec',
                  isMultiple: false,
                  searchType: 'projectInitiation',
                  prop: 'projectList',
                  extraData: {
                    projectInitiationStatusList: ['PIS04', 'PIS05'],
                  },
                },
              ]),
          {
            type: 'select',
            name: this.$t('contractAgency.company'),
            prop: 'projectCompanyCodeList',
            options: getUserCompanyList(),
            multiple: true,
          },
          {
            type: 'select',
            name: '账款类型',
            prop: 'quotaType',
            options: this.quotaTypeList,
          },
          /* {
            type: 'select',
            name: '授信类型',
            prop: 'creditType',
            options: this.creditTypeList,
          }, */
          /* {
            prop: 'validDate',
            name: '授信有效日期始',
            type: 'startDaterangePicker',
            placeholder: this.$t('credit.search.validDatePlaceholder'),
          },
          {
            prop: 'invalidDate',
            name: '授信有效日期止',
            type: 'endDaterangePicker',
            placeholder: this.$t('credit.search.invalidDatePlaceholder'),
          }, */
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.userInfo.businessGroup);
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getDic();
      this.getButtonList();
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'QUOTA_TYPE ', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.quotaTypeList = res.data.data;
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              for (var item of res.data.data) {
                this.creditTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.projectCodeList = [];
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        if (this.query.projectList !== 0) {
          this.query.projectList.map((item) => {
            query.projectCodeList.push(item.projectInitiationNo);
          });
        }
        // if (this.query.projectCompanyCodeList.length == 0) {
        //   this.query.projectCompanyCodeList.push(this.userInfo.userInfo.companyCode);
        // }
        this.$axios.post('/sales/creditLimitSummary/listProject', query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //导出
        if (type === 'export') {
          this.export();
        }
      },
      //跳转查看占用的已签未付款订单详情
      clickHnYfKqOrderAmount(e) {
        let path = {
          path: '/credit/hnYfKqAmountOrderList',
          name: 'hnYfKqAmountOrderList',
          meta: {
            keepAlive: false,
          },
          query: { id: e.row.id },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.$refs.siruiSearch.query;
        const params = filterEmpty(query);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios
          .post('/sales/creditLimitSummary/exportProject', filterEmpty(params))
          .then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //没有选择数据提示
      noSelectData() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
      },
      //双击事件
      dblclickEvent(value) {
        let pathName = '/project/projectAnalysis';
        let name = 'projectAnalysis';
        /* if(['advanceCharge','supplierRefund','storageAmount','deliveryAmount','receivables','salesRefund'].indexOf(value.column.property)>-1){
        pathName = "/credit/statisticsDetailColumns"
        name = "creditStatisticsDetailColumns"
      } */
        let path = {
          path: pathName,
          name: name,
          meta: {
            keepAlive: false,
          },
          query: { type: value.row.quotaType, projectCode: value.row.projectCode },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .credit .color {
    color: #0071fe;
    cursor: pointer;
  }
</style>
